import styled from '@emotion/styled';
import { H2 } from '../../../../common/Headings/Headings.styles';
import rem from '../../../../utils/rem/rem';

export const StyledH2 = styled(H2)`
  margin-bottom: 16px;
`;

export const ReviewChangesPage = styled.div`
  padding: 0 32px;
`;

export const TableSection = styled.div`
  margin-bottom: 32px;
`;

export const DescriptionSection = styled.div`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-rows: repeat(5, auto);
  row-gap: 16px;
  column-gap: 32px;
`;

export const Label = styled.div<{ row: number }>`
  font-weight: 700;
  grid-column: 1;
  grid-row: ${({ row }) => row};
`;

export const Value = styled.div<{ row: number }>`
  font-weight: 400;
  grid-column: 2;
  grid-row: ${({ row }) => row};
`;
